import {Component, ViewChild} from '@angular/core';
import {Config, Events, Keyboard, Nav, Platform} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import {InitStepCounterPage} from "../pages/init-step-counter/init-step-counter";
import {SplashPage} from "../pages/splash/splash";
import {Deeplinks} from "@ionic-native/deeplinks";
import {TransitionController} from "ionic-angular/transitions/transition-controller";
import {IOSTransition} from "ionic-angular/transitions/transition-ios";
import {registerLocaleData} from "@angular/common";
import localeDe from '@angular/common/locales/de';
import {Observable} from "rxjs";
import {Storage} from "@ionic/storage";
import {LocalStorageWrapper} from "../providers/local-storage-wrapper/local-storage-wrapper";


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = SplashPage;

  @ViewChild(Nav) navChild:Nav;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, deeplinks: Deeplinks, transitionCtrl: TransitionController, config: Config, public event: Events, private localStorage: LocalStorageWrapper) {
    var me = this;
    config.setTransition('md-transition', IOSTransition);

    this.localStorage.init();

    registerLocaleData(localeDe, 'de')

    platform.ready().then(() => {
      console.log('platform ready callback');

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleBlackTranslucent();
      // splashScreen.hide();

      if(platform.is('core')) {
        var ionApp = document.querySelector('ion-app');
        ionApp.classList.add('platform-android');
      }

      (window as any).statusBarHiddenByDefault = false;
      if(platform.is('android')) {
        statusBar.hide();
        (window as any).statusBarHiddenByDefault = true;
      }

      if((window as any).Keyboard && (window as any).Keyboard.hideFormAccessoryBar) {
        console.log('hide accessories');

        (window as any).Keyboard.hideFormAccessoryBar(false);

        window.addEventListener('keyboardWillHide', (event) => {
          document.body.style.height = "100%";
        });

        window.addEventListener('keyboardWillHide', (event) => {
          document.body.className = (document.body.className?document.body.className:'').replace('keyboard-open ios-keyboard-open', '')
        });
        window.addEventListener('keyboardDidHide', (event) => {
          document.body.className = (document.body.className?document.body.className:'').replace('keyboard-open ios-keyboard-open', '')
          this.event.publish('app:keyboard-did-hide-handler');
        });
      }

      var isAndroid = platform.is('android');

      let fullscreenActive = false;
      let orientation = (window as any).screen.orientation;

      function orientationChangeHandler(e) {
        console.log('fullscreen change', e);
        fullscreenActive = !fullscreenActive;
        if(fullscreenActive) {
          orientation.lock('landscape');
        } else {
          orientation.lock('portrait');
        }
      }

      if(isAndroid) {
        if(orientation && orientation.lock) {
          orientation.lock('portrait');
        }

        document.addEventListener("fullscreenchange", orientationChangeHandler, false);
        document.addEventListener("webkitfullscreenchange", orientationChangeHandler, false);
        document.addEventListener("mozfullscreenchange", orientationChangeHandler, false);
      }

      window.addEventListener('keyboardWillShow', (event) => {
        console.log('will show', document.querySelectorAll('ion-content').length);
        document.body.className = document.body.className?document.body.className:'' + "keyboard-open ios-keyboard-open"
        if(isAndroid) {
          document.body.style.height = "calc(100% - "+(event as any).keyboardHeight+"px)";
          if(document.querySelectorAll('ion-content').length) {
            let element = document.querySelectorAll('ion-content')[document.querySelectorAll('ion-content').length-1].querySelector('.intro-card-content-container');
            if(element) {
              document.querySelectorAll('ion-content')[document.querySelectorAll('ion-content').length-1].querySelector('.intro-card-content-container').scrollTop = 10000;
            }
          }
        } else {
          setTimeout(function() {
            if(document.querySelectorAll('ion-content').length) {
              let element = document.querySelectorAll('ion-content')[document.querySelectorAll('ion-content').length-1].querySelector('.intro-card-content-container');
              if(element) {
                document.querySelectorAll('ion-content')[document.querySelectorAll('ion-content').length-1].querySelector('.intro-card-content-container').scrollTop = 10000;
              }
            }
          }, 100);
        }

        this.event.publish('app:keyboard-will-show-handler');
      });
      window.addEventListener('keyboardDidShow', (event) => {
        console.log('keyboardDidShow', event);
        this.event.publish('app:keyboard-did-show-handler');
      });

      platform.pause.subscribe((event) => {
        this.event.publish('app:paused');
      }, () => {});
      platform.resume.subscribe((event) => {
        console.log('app resumed')
        this.event.publish('app:resumed');
      }, () => {});


      deeplinks.routeWithNavController(me.navChild, {
        // '/init-step-counter': InitStepCounterPage
      }).subscribe((match: any) => {
        console.log('routed', match)


        if(match.$link.host=='/forgotten') {
          let qs = match.$link.queryString;
          let token = qs.substr(qs.indexOf('token=')+6);
          console.log(qs, token);
          this.event.publish('password-forgotten-request', {token: token});
        }
        if(match.$link.host=='/paymentReceived') {
          this.event.publish('app:payment-received');
        }
        if(match.$link.host=='/paymentFailed') {
          this.event.publish('app:payment-failed');
        }
      }, (nomatch) => {
        console.log('Unmatched Routed', nomatch)
      })

    });


  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts